export default __webpack_public_path__ + "static/media/FuturaLT-Book.761341ca.ttf";